import {
    faDotCircle,
    faBars,
} from '@fortawesome/free-solid-svg-icons'

const getSidebarMenuList = (t) => [
    {
        icon: faBars, label: t('Tasks'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('Task'), link: '/admin/item', key: 'cms-task' },
            { icon: faDotCircle, label: t('Out Of Stock'), link: '/admin/outofstock', key: 'outofstock' },
            { icon: faDotCircle, label: t('Out Of Stock Recipient'), link: '/admin/outofstockrecipient', key: 'outofstockrecipient' },
        ]
    },
    {
        icon: faBars, label: t('In Room Dining'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('Additional Item'), link: '/admin/fnb-additional-item', key: 'fnb-additional-item' },
            { icon: faDotCircle, label: t('Recommendation'), link: '/admin/recommendation', key: 'recommendation' },
            { icon: faDotCircle, label: t('Offers'), link: '/admin/fnboffer', key: 'specialoffers' },
        ]
    },
    {
        icon: faBars, label: t('Shopping'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('Offers'), link: '/admin/retailoffer', key: 'retailoffers' },
        ]
    },
    {
        icon: faBars, label: t('Laundry'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('Choice of Delivery'), link: '/admin/laundry-delivery', key: 'laundry-delivery' },
            { icon: faDotCircle, label: t('Service'), link: '/admin/laundry-service', key: 'laundry-service' },
        ]
    },
    {
        icon: faBars, label: t('Transportation'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('Transportation Type'), link: '/admin/cms-transportation-type', key: 'cms-transportation-type' }
        ]
    },
    {
        icon: faBars, label: t('Facility Booking'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('Booking Category'), link: '/admin/booking-category', key: 'booking-category' },
            { icon: faDotCircle, label: t('Booking Sub Category'), link: '/admin/booking-sub-category', key: 'booking-sub-category' },
            { icon: faDotCircle, label: t('Booking Item'), link: '/admin/booking-item', key: 'booking-item' },
            { icon: faDotCircle, label: t('Booking Transaction'), link: '/admin/booking-transaction', key: 'booking-transaction' }
        ]
    },
    {
        icon: faBars, label: t('Others'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('Hotel Offers'), link: '/admin/eventhotel', key: 'events' },
            { icon: faDotCircle, label: t('Hotel Facilities'), link: '/admin/hotelfacility', key: 'facilities' },
            { icon: faDotCircle, label: t('Popups'), link: '/admin/popup', key: 'popups' },
            { icon: faDotCircle, label: t('Hotel Description'), link: '/admin/hoteldescription', key: 'hoteldescription' },
            { icon: faDotCircle, label: t('Compendiums'), link: '/admin/compendium', key: 'sidebars' },
            { icon: faDotCircle, label: t('Audit Logs'), link: '/admin/audit-log', key: 'audit-log' },
            { icon: faDotCircle, label: t('Payment Type'), link: '/admin/cms-payment-type', key: 'cms-payment-type' },
            { icon: faDotCircle, label: t('Guest Login Log'), link: '/admin/guest-login-log', key: 'guestloginlog' },
        ]
    }
];

const getSuperAdminMenuList = (t) => [
    {
        icon: faBars, label: t('Tasks'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('Task'), link: '/admin/item', key: 'cms-task' },
            { icon: faDotCircle, label: t('Out Of Stock'), link: '/admin/outofstock', key: 'outofstock' },
            { icon: faDotCircle, label: t('Out Of Stock Recipient'), link: '/admin/outofstockrecipient', key: 'outofstockrecipient' },
        ]
    },
    {
        icon: faBars, label: t('In Room Dining'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('Additional Item'), link: '/admin/fnb-additional-item', key: 'fnb-additional-item' },
            { icon: faDotCircle, label: t('Recommendation'), link: '/admin/recommendation', key: 'recommendation' },
            { icon: faDotCircle, label: t('Offers'), link: '/admin/fnboffer', key: 'specialoffers' },
        ]
    },
    {
        icon: faBars, label: t('Shopping'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('Offers'), link: '/admin/retailoffer', key: 'retailoffers' },
        ]
    },
    {
        icon: faBars, label: t('Laundry'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('Choice of Delivery'), link: '/admin/laundry-delivery', key: 'laundry-delivery' },
            { icon: faDotCircle, label: t('Service'), link: '/admin/laundry-service', key: 'laundry-service' },
        ]
    },
    {
        icon: faBars, label: t('Transportation'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('Transportation Type'), link: '/admin/cms-transportation-type', key: 'cms-transportation-type' }
        ]
    },
    {
        icon: faBars, label: t('Facility Booking'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('Booking Category'), link: '/admin/booking-category', key: 'booking-category' },
            { icon: faDotCircle, label: t('Booking Sub Category'), link: '/admin/booking-sub-category', key: 'booking-sub-category' },
            { icon: faDotCircle, label: t('Booking Item'), link: '/admin/booking-item', key: 'booking-item' },
            { icon: faDotCircle, label: t('Booking Transaction'), link: '/admin/booking-transaction', key: 'booking-transaction' }
        ]
    },

    {
        icon: faBars, label: t('Payments'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('History'), link: '/admin/payment-history', key: 'payment-history' },
        ]
    },

    {
        icon: faBars, label: t('Others'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('Hotel Offers'), link: '/admin/eventhotel', key: 'events' },
            { icon: faDotCircle, label: t('Hotel Facilities'), link: '/admin/hotelfacility', key: 'facilities' },
            { icon: faDotCircle, label: t('Popups'), link: '/admin/popup', key: 'popups' },
            { icon: faDotCircle, label: t('Hotel Description'), link: '/admin/hoteldescription', key: 'hoteldescription' },
            { icon: faDotCircle, label: t('Compendiums'), link: '/admin/compendium', key: 'sidebars' },
            { icon: faDotCircle, label: t('Audit Logs'), link: '/admin/audit-log', key: 'audit-log' },
            { icon: faDotCircle, label: t('Payment Type'), link: '/admin/cms-payment-type', key: 'cms-payment-type' },
            { icon: faDotCircle, label: t('Guest Login Log'), link: '/admin/guest-login-log', key: 'guestloginlog' },
        ]
    },
    {
        icon: faBars, label: t('Customization'), key: 'layout', subMenu: [
            { icon: faDotCircle, label: t('Template'), link: '/admin/template', key: 'template' },
            { icon: faDotCircle, label: t('Language'), link: '/admin/cms-language', key: 'cms-language' },
            { icon: faDotCircle, label: t('Web Setting'), link: '/admin/web-setting', key: 'web-setting' },
            { icon: faDotCircle, label: t('Menu'), link: '/admin/cms-menu', key: 'cms-menu' },
            { icon: faDotCircle, label: t('Items Import/Export'), link: '/admin/import-items', key: 'importitems' }
        ]
    }
]

export {
    getSidebarMenuList,
    getSuperAdminMenuList
}
